import { render, staticRenderFns } from "./invoice2.vue?vue&type=template&id=df7fdc0c&scoped=true"
import script from "./invoice2.vue?vue&type=script&lang=js"
export * from "./invoice2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df7fdc0c",
  null
  
)

export default component.exports